import styled, { css } from 'styled-components'
import {
  flex, flexAlign, overflowLimitTo,
} from './ReceivementFreshTag.style.mixins'

const darkGray = (props) => props.theme.colors.darkGray

export const TagContainer = styled.div`
    ${flex()}
    aspect-ratio: 4/3;
    border: 2px solid ${darkGray};
    width: 11cm;
    height: 9cm;
`

export const TagHeader = styled.div`
    ${flex('row', 0.6)}
    border-bottom: 1px solid ${darkGray};
`

export const TagHeaderColumn = styled.div<{ hasRightBorder?: boolean, hasRows?: boolean, centered?: boolean }>`
    ${({ centered = false }) =>
    centered
            && css`
                align-items: center;
            `}

    ${({ hasRightBorder = false }) =>
    hasRightBorder
            && css`
                border-right: 1px solid ${darkGray}; 
                text-align: center;
            `}

    ${({ hasRows = false }) =>
    css`
        ${hasRows ? flex('column', 2) : flex()}
    `}
`

export const Text = styled.span<{ limit?: number, size?: number }>`
    ${({ size }) =>
    css`
            font-size: ${size}px;
        `}
    ${({ limit }) =>
    limit
        && css`
            ${overflowLimitTo(limit)}
        `}
`

export const TagInformationFooter = styled.div`
    ${flex('row')}
    ${flexAlign('center', 'center')}
    font-size: 14px;
    padding: 0 6px;
    flex-grow: 0;

    span:not(:first-child):before {
        content: "-";
        padding: 0 4px;
    }
`
